import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { TextField } from 'shared/domains/forms';
import { InfoContainer } from './styled';
export function CustomerIdField() {
    const [, , helpers] = useField('customerId');
    const handleGenerateId = () => {
        const prefix = 'PROJECT';
        const random = Math.floor(Math.random() * 999999) + 1;
        const formattedRandom = random.toString().padStart(6, '0');
        const generatedId = `${prefix}-${formattedRandom}`;
        helpers.setValue(generatedId);
    };
    return (<Box flexDirection="column" gap="sm">
      <TextField name="customerId" label={t({ message: 'Project ID', comment: 'Edit project dialog - Project id label' })} placeholder={t({
            message: 'Project ID...',
            comment: 'Edit project dialog - Project ID input placeholder',
        })} adornmentRight={<Button type="button" size="xs" appearance="secondary" onClick={handleGenerateId}>
            <Trans comment="Create project dialog - Generate project ID button label">Generate ID</Trans>
          </Button>}/>
      <InfoContainer>
        <Falcon icon="info-circle" $color="text.100"/>
        <Typography $fontSize="small" $appearance="200">
          <Trans comment="Create project dialog - Project ID info text">
            Add a project ID to help identify and search for this project in Pocketlaw (optional)
          </Trans>
        </Typography>
      </InfoContainer>
    </Box>);
}
